<script>
import ResourceService from '@/services/resources/users_service';
import SiteView from './SiteView.vue';

export default {
  extends: SiteView,
  components: {
    ActionBar: () => import('@/components/action_bars/UsersActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-home-account',
      urlFragment: 'users',
      headers: [
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Email', value: 'email' },
      ],
      sortBy: ['firstName', 'lastName'],
    };
  },
  computed: {
    resourceParams() {
      return {
        filter: {
          site: this.siteId,
        },
      };
    },
  },
};
</script>
